/**
 * @generated SignedSource<<721b0cb815bfcdc7ed0e21470f8064fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useChatUnreadCountQuery$variables = Record<PropertyKey, never>;
export type useChatUnreadCountQuery$data = {
  readonly channelsUnreadCount: number;
};
export type useChatUnreadCountQuery = {
  response: useChatUnreadCountQuery$data;
  variables: useChatUnreadCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "channelsUnreadCount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useChatUnreadCountQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useChatUnreadCountQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "322146e9092e2d5137eb71443e340422",
    "id": null,
    "metadata": {},
    "name": "useChatUnreadCountQuery",
    "operationKind": "query",
    "text": "query useChatUnreadCountQuery {\n  channelsUnreadCount\n}\n"
  }
};
})();

(node as any).hash = "dd9fbc890e00333508a935ea0f687026";

export default node;
